import type { WorkflowDiagramToolHandlers } from './useWorkflowDiagramToolHandlers.types';

import { useEffect } from 'react';

export const useWorkflowDiagramToolLifecycle = ({
  onInitialNodesSet
}: {
  onInitialNodesSet: WorkflowDiagramToolHandlers['handleInitialNodesSet'];
}) => {
  useEffect(onInitialNodesSet, [onInitialNodesSet]);
};
